import { Reducer } from 'redux';

import { TransportCardsPlaceState, TransportCardsPlaceTypes } from './types';

const INITIAL_STATE: TransportCardsPlaceState = {
  transportCardsPlaceList: [],
  transportCardsPlaceData: {
    id: '',
    name: '',
    supervisorId: '',
    transportOperatorId: '',
    TransportCards: [],
    Addresses: [],
    TransportSupervisor: {
      id: '',
      name: '',
      email: '',
      photoUrl: '',
      createdAt: '',
      updatedAt: '',
    },
    createdAt: '',
    updatedAt: '',
  },
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<TransportCardsPlaceState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // LIST TRANSPORT CARDS PLACE
    case TransportCardsPlaceTypes.LIST_TRANSPORT_CARDS_PLACE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardsPlaceList: INITIAL_STATE.transportCardsPlaceList,
      };
    case TransportCardsPlaceTypes.LIST_TRANSPORT_CARDS_PLACE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardsPlaceList: action.payload.transportCardsPlaceList,
        totalCount: action.payload.totalCount,
      };
    case TransportCardsPlaceTypes.LIST_TRANSPORT_CARDS_PLACE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardsPlaceList: INITIAL_STATE.transportCardsPlaceList,
      };

    // GET TRANSPORT CARDS PLACE
    case TransportCardsPlaceTypes.GET_TRANSPORT_CARDS_PLACE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardsPlaceData: INITIAL_STATE.transportCardsPlaceData,
      };
    case TransportCardsPlaceTypes.GET_TRANSPORT_CARDS_PLACE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardsPlaceData: action.payload.transportCardsPlaceData,
      };
    case TransportCardsPlaceTypes.GET_TRANSPORT_CARDS_PLACE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardsPlaceData: INITIAL_STATE.transportCardsPlaceData,
      };

    // FILTER TRANSPORT CARDS PLACE
    case TransportCardsPlaceTypes.FILTER_TRANSPORT_CARDS_PLACE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        transportCardsPlaceList: INITIAL_STATE.transportCardsPlaceList,
      };
    case TransportCardsPlaceTypes.FILTER_TRANSPORT_CARDS_PLACE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        transportCardsPlaceList: action.payload.transportCardsPlaceList,
        totalCount: action.payload.totalCount,
      };
    case TransportCardsPlaceTypes.FILTER_TRANSPORT_CARDS_PLACE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        transportCardsPlaceList: INITIAL_STATE.transportCardsPlaceList,
      };

    // CREATE TRANSPORT CARDS PLACE
    case TransportCardsPlaceTypes.CREATE_TRANSPORT_CARDS_PLACE_REQUEST:
      return { ...state, loading: true, error: false };

    case TransportCardsPlaceTypes.CREATE_TRANSPORT_CARDS_PLACE_SUCCESS:
      return { ...state, loading: false, error: false };

    case TransportCardsPlaceTypes.CREATE_TRANSPORT_CARDS_PLACE_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE TRANSPORT CARDS PLACE
    case TransportCardsPlaceTypes.UPDATE_TRANSPORT_CARDS_PLACE_REQUEST:
      return { ...state, loading: true, error: false };

    case TransportCardsPlaceTypes.UPDATE_TRANSPORT_CARDS_PLACE_SUCCESS:
      return { ...state, loading: false, error: false };

    case TransportCardsPlaceTypes.UPDATE_TRANSPORT_CARDS_PLACE_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE TRANSPORT CARDS PLACE
    case TransportCardsPlaceTypes.DELETE_TRANSPORT_CARDS_PLACE_REQUEST:
      return { ...state, loading: true, error: false };

    case TransportCardsPlaceTypes.DELETE_TRANSPORT_CARDS_PLACE_SUCCESS:
      return { ...state, loading: false, error: false };

    case TransportCardsPlaceTypes.DELETE_TRANSPORT_CARDS_PLACE_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
